import { render, staticRenderFns } from "./DisqualificationTooltip.vue?vue&type=template&id=36966771"
import script from "./DisqualificationTooltip.vue?vue&type=script&lang=js"
export * from "./DisqualificationTooltip.vue?vue&type=script&lang=js"
import style0 from "./DisqualificationTooltip.vue?vue&type=style&index=0&id=36966771&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports